import React from 'react';
import BroadcastIndex from 'pages/workshop/broadcast';

export default function () {
  return <BroadcastIndex version="replay" />;
}
